import { t } from "@/i18n-js/instance";
import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";

const LOCALE_ROOT = "paywall_checkout.form";

interface AuthenticatingSectionProps {
  messageType: "success" | "authenticating";
  shouldShowMessage?: boolean;
}

export const AuthenticatingSection = ({
  shouldShowMessage = true,
  messageType,
}: AuthenticatingSectionProps) => (
  <div className="flex flex-col items-center justify-center gap-3">
    <div className="flex items-center justify-center">
      <Loader className="!py-0" />
    </div>
    {shouldShowMessage && (
      <div className="text-center">
        <Typography.BodySm weight="normal" color="text-default">
          {t([
            LOCALE_ROOT,
            messageType === "success"
              ? "completing_login"
              : "authenticating_account",
          ])}
        </Typography.BodySm>
      </div>
    )}
  </div>
);
